import { render, staticRenderFns } from "./ServiceReport.vue?vue&type=template&id=39192505&scoped=true"
import script from "./ServiceReport.vue?vue&type=script&lang=ts"
export * from "./ServiceReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39192505",
  null
  
)

export default component.exports